import React, {useEffect, useState} from 'react';
import Frame from "../components/layout/Frame";
import Container from "react-bootstrap/Container";
import {Col, Row} from "react-bootstrap";
import TableSystem from "../components/tables/TableSystem";
import {getSystem} from "../api/apiClient";

const ConfSystem = () => {

  /* pagination을 위한 state */
  const [listPageSize, setListPageSize] = useState(15);
  const [tableList, setTableList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);

  // 검색 조건
  const [searchParam, setSearchParam] = useState({});
  // 검색 버튼 클릭했는지
  const [isSearch, setIsSearch] = useState(true);

  /* 이동약자 시설 목록 갱신 */
  const updateList = () => {
    getSystem(currentPage, listPageSize)
        .then((res) => {
          if (res.data.data !== undefined) {
            setTableList(res.data.data.list);
            setTotal(res.data.data.total);
          }
        });
  };


  useEffect(() => {
    updateList();
  }, [isSearch, currentPage, listPageSize]);

  return (
      <Frame
          propIsActiveHeader={true}
          propIsActiveSidebar={true}
      >
        <Container fluid>
          <Row className={"p-3"}>
            <Col md={12} className={"table-container mt-3 py-2 mw-100"}>
              <TableSystem
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  listPageSize={listPageSize}
                  setListPageSize={setListPageSize}
                  total={total}
                  tableList={tableList}
                  updateList={updateList}
                  setIsSearch={setIsSearch}
                  searchParam={searchParam}
                  setSearchParam={setSearchParam}
                  setTableList={setTableList}
                  setTotal={setTotal}
              />
            </Col>
          </Row>
        </Container>
      </Frame>
  );
};

export default ConfSystem;
